import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img src="/logo.png" alt="Montreal Kosher" className="not-found-logo" />
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">Page Not Found</h2>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button className="not-found-button" onClick={handleGoHome}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

export default NotFound;
